import React, { useState } from 'react';
import { makePick } from '../repository/draftsRepository';

interface PickFormProps {
    draftUuid: string;
    onPickMade: () => void;
}

const PickForm: React.FC<PickFormProps> = ({ draftUuid, onPickMade }) => {
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (!value.trim()) {
            setError('Please enter your pick');
            return;
        }

        setLoading(true);

        const result = await makePick(draftUuid, value.trim());

        if ('error' in result) {
            setError(result.error);
            setLoading(false);
            return;
        }

        setValue('');
        setLoading(false);
        onPickMade();
    };

    return (
        <form onSubmit={handleSubmit} className="pick-form">
            {error && <div className="error-message">{error}</div>}
            <div className="pick-input-group">
                <input
                    type="text"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder="Enter your pick..."
                    disabled={loading}
                    autoFocus
                />
                <button type="submit" className="btn-primary" disabled={loading || !value.trim()}>
                    {loading ? 'Submitting...' : 'Submit Pick'}
                </button>
            </div>
        </form>
    );
};

export default PickForm;
